import { Route, Routes } from "react-router-dom";
import { ProSidebarProvider } from "react-pro-sidebar";

import BlankLayout from "../layouts/BlankLayout";
import { map } from "lodash";
import otherRoutes from "./other.routes.config";

import StepperLayout from "@/layouts/StepperLayout";
import { OnboardingRoutes } from "./onboarding.route.component.config";
import ProtectedRouteWrapper from "./ProtectedRouteWrapper";
import ScrollToTop from "@/components/common/ScrollToTop";

const OnboardingPartnerRoutes = () => {

  return (
    <ProSidebarProvider>
      <ScrollToTop />
      <Routes>
        <Route
          element={
            <ProtectedRouteWrapper permissions={["PRE_KYC"]}>
              <StepperLayout />
            </ProtectedRouteWrapper>
          }
        >
          {OnboardingRoutes &&
            map(OnboardingRoutes, (value, key) => (
              <Route
                path={value.path}
                element={
                  <ProtectedRouteWrapper permissions={value.permission}>
                    {value.element}
                  </ProtectedRouteWrapper>
                }
                key={key}
              />
            ))}
        </Route>

        {/* 404 for frontend */}
        <Route element={<BlankLayout />}>
          {otherRoutes &&
            map(otherRoutes, (val, k) => (
              <Route path={val.path} element={val.element} key={k} />
            ))}
        </Route>
      </Routes>
    </ProSidebarProvider>
  );
};

export default OnboardingPartnerRoutes;
